import { SubscriptionPlanType } from "@coeff/api";
import { Tag as TagAD } from "antd";
import * as React from "react";
import styled from "styled-components";

import { COLORS } from "../constants";
import { planNameFromType } from "../utils";

const StyledTag = styled(TagAD)`
  border-radius: 5px;

  &.ant-tag-orange {
    background-color: #feedcb;
    color: #d17a1d;
    border-color: #d17a1d;
  }

  &.ant-tag-blue {
    background-color: ${COLORS.coeblue4};
    border-color: ${COLORS.coeblue4};
    color: white;
  }

  &.ant-tag-green {
    background-color: ${COLORS.greenBg5};
    color: ${COLORS.green};
  }

  &.ant-tag-red {
    background-color: ${COLORS.redBg};
    color: ${COLORS.red};
  }

  &.no-border {
    border: none;
  }

  &.planType {
    color: ${COLORS.black85};
    font-weight: 500;
    padding: 0px 5px;
    line-height: 1.5;
  }

  &.planType.plus {
    color: white;
  }
`;

export const Tag = StyledTag;

type PlanTagProps = {
  planType?: SubscriptionPlanType;
  icon?: React.ReactNode;
};

export const PlanTag: React.FC<PlanTagProps> = ({ planType, icon }) => {
  return planType ? (
    <StyledTag
      className={`planType ${planType}`}
      color={
        planType === "starter"
          ? COLORS.coeblue
          : ["pro", "enterprise", "custom"].includes(planType)
          ? COLORS.yellow
          : COLORS.greenBg4
      }
    >
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {icon && <span>{icon}</span>}
        <span>{planNameFromType(planType)}</span>
      </div>
    </StyledTag>
  ) : null;
};
